import { IMarker } from './../../../shared/components/map/map.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ResultsContainer, HotelPreview } from '../../results/results.container';
import { Component, OnInit } from '@angular/core';
import { HotelHeaderInfo } from '../../../core/store/general/state';
import { experiencesIconsMapping } from '../../../core/models/results/experienceMapping.model';
import { Angulartics2 } from 'angulartics2';
import { ResultsService } from '../../../core/services/results.service';
import { ChangeLasteRequestAsked } from '../../../core/store/general/actions';
import { SharedContainer } from '../../../shared/shared.container';
import { Meta } from '@angular/platform-browser';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { SwiperOptions } from 'swiper';

declare const fbq: any;
export enum RoomMode {
    WITH_CANCELLATION = 1,
    NON_REFUNDABLE = 2,
    BOTH = 3
}
@Component({
    selector: 'app-property-preview',
    templateUrl: 'propertypreview.html',
    styleUrls: ['propertypreview.css', 'propertypreview.scss']
})

export class OwnerPropertyPreviewComponent implements OnInit, NgxUsefulSwiperModule {
    config: SwiperOptions = {
        pagination: { el: '.swiper-pagination', clickable: true, dynamicBullets: true },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        spaceBetween: 30
    };

    images = [];

    appLogo = '../../../../../assets/img/logo-home-vervendo.svg';

    offerInfo;
    offerId;
    hotelName;
    tabHeaderInfo: TabHeaderInfo;
    hotelDscription: HotelDescription;
    facilitiesTab: FacilitiesTabInfo;
    locations: LocationTabInfo;
    roomOffers: Array<RoomInfo>;
    markers = new Array<IMarker>();
    mapCenter = { latitude: 0, longitude: 0 };
    hotels = new Array<HotelPreview>();
    experiencesDate = new Map();

    selectedRoomTypes = new Map();
    mealtypes = new Set<string>();
    experiencesList = new Set<string>();
    requestForSearch;
    roomsForBooking = new Map();
    offerNote;
    hotelierIcon;
    currentTotalCost = 0;
    public selectedExperiences = new Array();
    hotelInfo;
    isTextHighlighted = false;

    mobileFullsreenWindow = {
        isSortByOpen: false,
        isFilterOptionsOpen: false,
        isMapOpen: false
    };
    loading = false;

    formattedFromDate: any;
    formattedToDate: any;

    isOffer: boolean;
    isMapDesktopOpen: Boolean = false;

    constructor(private resultsContainer: ResultsContainer,
        private route: ActivatedRoute, private router: Router,
        private resultService: ResultsService, private sharedContainer: SharedContainer,
        private angulartics2: Angulartics2, private meta: Meta) {
        this.roomOffers = new Array<RoomInfo>();
        /*this.route.queryParams
            .subscribe(params => {
                if (params.or) {
                    this.isOffer = false;
                } else {
                    this.isOffer = true;
                }
                console.log(params);
                if (params.checkInDate && params.checkOutDate && params.adults < 100 && params.children) {
                    this.fillRequestForSearchFromParams(params); // {order: "popular"}
                } else {
                    this.router.navigate(['../']);
                }
            });*/
        /*this.meta.addTags([
            { name: 'viewport', content: 'minimum-scale=1 width=device-width initial-scale=.5 user-scalable=no' }
        ], true);*/
    }
    ngOnInit() {
        this.resultsContainer.changeHeader('PropertyPreview');
        let hotelid;
        this.route.params.subscribe(params => {
            hotelid = params.hotelid;
        });
        // this.offerId = this.route.pathFromRoot[2].snapshot.paramMap.get('hotelid');
        this.resultsContainer.offerId = hotelid;
        this.resultsContainer.currentTotalCost = this.currentTotalCost;
        this.loading = true;
        // this.resultsContainer.enableSpinner(true);
        /*this.resultsContainer.getUserInformation().subscribe(usr => {
                if (this.resultsContainer.userLoggedInAfter){
                    if (usr !== null) {
                        this.resultsContainer.sendRequestToHotels(this.offerInfo.offer.bookingRequest);
                    }
                }
            });*/
        // this.resultsContainer.requestForSearch.hotelid = this.offerId;
        // this.resultsContainer.requestForSearch.offerid = 0;
        // this.resultsContainer.getSingleOffer(this.offerId).subscribe(offerInfo => {
        this.resultService.getPropertyPreview(hotelid).subscribe((offerInfo: any) => {
            this.offerInfo = offerInfo;
            this.offerInfo.damageDeposit = 0;
            // this.resultsContainer.offerInfo = offerInfo;
            // this.resultsContainer.requestForSearch.offerid = offerInfo.offer.id;
            // this.resultsContainer.fillRequestInfoNew(this.resultsContainer.requestForSearch);
            // this.resultsContainer.bookingRequest = this.offerInfo.offer.bookingRequest;
            const contentsFb = new Array();
            /*this.offerInfo.offerRooms.forEach(room => {
                const constentInfo = {
                    id: room.room.id,
                    quantity: 1,
                    item_price: room.room.offerPrice
                };
                contentsFb.push(constentInfo);
            });*/

            const hotelInfo: HotelHeaderInfo = {
                title: offerInfo.hotel.name, stars: offerInfo.hotel.starRating,
                location: offerInfo.hotel.addressLine1 + ',' + offerInfo.hotel.addressCity + ',' + offerInfo.hotel.country,
                cost: 0
            };

            // this.resultsContainer.setHeaderInfo(hotelInfo);
            this.hotelName = offerInfo.hotel.name;

            // this.resultsContainer.fillRequestInfo(this.offerInfo.offer.bookingRequest)
            // console.log(this.offerInfo.offer.bookingRequest.noOfChildren);
            this.fillTabHeaderInfo(5, 3);

            // this.fillTabHeaderInfo(this.resultsContainer.requestForSearch.adults, this.resultsContainer.requestForSearch.children);
            offerInfo.propertyPics.map(pic => this.images.push(pic));
            if (offerInfo.propertyPics[0]) {
                offerInfo.propertyPics[0].preloaded = true;
            }

            this.hotelDscription = {
                description: this.offerInfo.hotel.description,
                staffDescription: this.offerInfo.hotelStaff,
                personalDescription: this.offerInfo.hotel.personalDescription,
                languages: this.offerInfo.hotelLanguages.map(language => language.language.language)
            };

            this.facilitiesTab = {
                general: this.offerInfo.hotel.hotelFacilitiesCollection.filter(
                    facility => facility.facility.facilityGroupName === 'General').map(facility => facility.facility.name),
                activities: this.offerInfo.hotel.hotelFacilitiesCollection.filter(
                    facility => facility.facility.facilityGroupName === 'Activities').map(facility => facility.facility.name),
                services: this.offerInfo.hotel.hotelFacilitiesCollection.filter(
                    facility => facility.facility.facilityGroupName === 'Services').map(facility => facility.facility.name),

            };
            if (this.offerInfo.hotelAcceptsPets) {
                this.facilitiesTab.general.push('Pets Accepted');
            } else {
                this.facilitiesTab.general.push('Pets Not Accepted');
            }
            this.locations = {
                shopping: this.fillLocationInfo('Shopping and Dining'),
                transportation: this.fillLocationInfo('Transportation'),
                nearby: this.fillLocationInfo('Near By'),
                healthCenters: this.fillLocationInfo('Health centers'),
                culture: this.fillLocationInfo('Culture'),
                landmarks: this.fillLocationInfo('Landmarks'),
                emergencyStations: this.fillLocationInfo('Emergency stations')
            };

            this.fillRoomOffers();
            // this.fillMealTypes();
            // this.fillHotelExtrasPeriods(offerInfo);
            this.fillMapInfo();
            // this.fillExperiences(offerInfo);
            // this.fillOfferNote(offerInfo);
            // this.fillSelectedExperiences();
            // this.resultsContainer.enableSpinner(false);
            this.loading = false;

        }, (error: any) => console.log(error));



    }
    fillRequestForSearchFromParams(data) {
        this.requestForSearch = {
            fromdate: data.checkInDate,
            todate: data.checkOutDate,
            rooms: data.rooms,
            adults: data.adults,
            children: data.children[0],
            hotelextras: data.experiences,
            experiencestitle: data.experiences_title,
            offset: 0,
            limit: 10,
            requestId: data.requestId
        };
        this.resultsContainer.requestForSearch = this.requestForSearch;
    }
    getAdult(): any {
        return this.resultsContainer.requestForSearch.adults;
    }
    getChildrens(): any {
        return this.resultsContainer.requestForSearch.children;
    }
    fillSelectedExperiences() {
        if (this.selectedExperiences.length > 0) { return; }
        /*this.offerInfo.offer.bookingRequest.bookingRequestExtrasCollection.forEach(experience => {
            if (experience.optionalExtraCategory) {
                const exp = {
                    id: experience.bookingExtraCategory.id,
                    title: experience.bookingExtraCategory.category,
                    icon: experiencesIconsMapping.get(experience.bookingExtraCategory.id)
                };
                this.selectedExperiences.push(exp);
            }
        });*/

        this.offerInfo.extras.forEach(experience => {
            /*const exp = {
                id: experience.bookingExtraCategory.id,
                title: experience.bookingExtraCategory.category,
                icon: experiencesIconsMapping.get(experience.bookingExtraCategory.id)
            };
            this.selectedExperiences.push(exp);*/
            if (experience.optionalExtraCategory) {
                const exp = {
                    id: experience.optionalExtraCategory.id,
                    title: experience.optionalExtraCategory.category,
                    icon: experiencesIconsMapping.get(experience.optionalExtraCategory.id)
                };
                this.selectedExperiences.push(exp);
            }
        });

        /*this.selectedExperiences.forEach(experience => {
            // if (experience.bookingExtraCategory) {
                // if (hotelPreview.requestInfo.hotelextras) {
                    const item = this.offerInfo.offer.bookingRequest.bookingRequestExtrasCollection
                        .find(exp => {
                            if (experience.bookingExtraCategory) {
                                return exp.id === experience.bookingExtraCategory.id ? true : false;
                            }
                            return false;
                            }
                        );
                    item ? experience.hasTick = true : experience.hasTick = false;

                // experience.icon = experiencesIconsMapping.get(experience.optionalExtraCategory.id);

        });*/

    }

    fillExperiences(offer) {
        // offer.offer.bookingOfferOptionalExtrasCollection.forEach(extra =>  this.experiencesList.add(extra.fkOptionalExtra.title));
    }

    fillOfferNote(offer) {
        /*if (offer.hotelStaff[0]) {
           const offernote = {
               text: offer.offer.personalRequestResponse,
               image: 'data:image/png;base64,' + offer.hotelStaff[0].picture
            };
           this.offerNote = offernote;
        }*/

        /*if (offer.offer.personalRequestResponse !== null) {
           if (offer.hotelier) {
               const offernote = {
                   text: offer.offer.personalRequestResponse,
                   image: 'data:image/png;base64,' + offer.hotelier.picture
               };
               this.offerNote = offernote;
           } else {
               const offernote = {
                   text: offer.offer.personalRequestResponse,
                   image: ''
               };
               this.offerNote = offernote;
           }
       }*/
    }

    fillHotelExtrasPeriods(offerInfo) {
        let roomTypeId = -1;
        /*const fromDate = offerInfo.offer.bookingRequest.fromDate;
        const toDate = offerInfo.offer.bookingRequest.toDate;*/

        const fromDate = this.resultsContainer.requestForSearch.fromdate;
        const toDate = this.resultsContainer.requestForSearch.todate;
        const currentDate = new Date(fromDate);
        const endDate = new Date(toDate);
        const presetDates = [];
        while (currentDate <= endDate) {
            presetDates.push(currentDate.getTime());
            currentDate.setDate(currentDate.getDate() + 1);
        }

        this.roomOffers.map(room => {
            const hotelExtrasTmp = this.offerInfo.extras;
            const hotelExtras = room.experiences; // hotelExtrasTmp.concat(room.roomExtras);
            roomTypeId = room.roomTypeId; // room.roomType.id;

            const ids = [];
            let i = 0;
            hotelExtras.map(experience => {
                if (experience.period.id === 4) {
                    ids.push(experience.id);
                    this.resultsContainer.getActivePeriodOfOptionalFacilty(experience.id, roomTypeId, fromDate, toDate)
                        .subscribe(dates => {
                            const experienceId = ids[i];
                            const calendarActiveDates: CalendarActiveDates = {
                                dates: dates,
                                color: experience.color,
                                title: experience.title
                            };
                            if (!this.experiencesDate.has(experienceId)) { this.experiencesDate.set(experienceId, calendarActiveDates); }
                            i++;
                        });
                } else {
                    const calendarActiveDates: CalendarActiveDates = {
                        dates: presetDates,
                        color: experience.color,
                        title: experience.title
                    };
                    if (!this.experiencesDate.has(experience.id)) { this.experiencesDate.set(experience.id, calendarActiveDates); }
                }
            });
        });
    }

    fillMapInfo() {
        const marker: IMarker = {
            lat: this.offerInfo.hotel.latitude,
            lng: this.offerInfo.hotel.longitude,
            label: this.offerInfo.hotel.id,
            draggable: false
        };
        let mapPrice = 0;
        this.markers.push(marker);
        this.mapCenter.latitude = this.offerInfo.hotel.latitude; // this.offerInfo.offer.bookingRequest.latitude;
        this.mapCenter.longitude = this.offerInfo.hotel.longitude; // this.offerInfo.offer.bookingRequest.longitude;
        this.offerInfo.offerRooms.map(room => {
            const price = room.room.offerPrice;
            const availability = room.room.offerPrice;
            if (price > 0 && availability > 0) {
                mapPrice = price;
            }
        });
        const hotelPreview: HotelPreview = {
            minPrice: mapPrice,
            title: this.offerInfo.hotel.name,
            pictures: this.offerInfo.propertyPics,
            stars: this.offerInfo.hotel.starRating,
            reviews: 0,
            experiences: [],
            description: '',
            optionaRequests: [],
            id: this.offerInfo.hotel.id,
            offerId: null, // this.offerInfo.offer.id,
            offerType: ''
        };
        /*if (this.offerInfo.offer.optExtrasAvail === 1 || this.offerInfo.offer.optExtrasAvail === 0) {
            hotelPreview.experiencesAvailable = 'icon-no';
            hotelPreview.experiencesPriority = 3;
        } else if (this.offerInfo.offer.optExtrasAvail === 2) {
            hotelPreview.experiencesAvailable = 'icon-yes';
            hotelPreview.experiencesPriority = 1;
        } else if (this.offerInfo.offer.optExtrasAvail === 3) {
            hotelPreview.experiencesAvailable = 'icon-some';
            hotelPreview.experiencesPriority = 2;
        }

        if (this.offerInfo.offer.optFacilitiesAvail === 1 || this.offerInfo.offer.optFacilitiesAvail === 0) {
            hotelPreview.optionalAvailable = 'icon-no';
            hotelPreview.optFacilitiesPriority = 3;
        } else if (this.offerInfo.offer.optFacilitiesAvail === 2) {
            hotelPreview.optionalAvailable = 'icon-yes';
            hotelPreview.optFacilitiesPriority = 1;
        } else if (this.offerInfo.offer.optFacilitiesAvail === 3) {
            hotelPreview.optionalAvailable = 'icon-some';
            hotelPreview.optFacilitiesPriority = 2;
        }

        if (this.offerInfo.offer.personalRequestAccepted !== null &&
            this.offerInfo.offer.personalRequestAccepted !== undefined) {
                hotelPreview.personalRequestIcon = 'icon-yes';
        } else {
            hotelPreview.personalRequestIcon = 'icon-no';
        }

        this.offerInfo.offer.bookingOfferRoomCollection.map( room => {
                if (hotelPreview.minPrice > room.offerPrice) {
                    hotelPreview.minPrice = room.offerPrice;
                    hotelPreview.minDefaultPrice = room.defaultPrice;
                    if (hotelPreview.minDefaultPrice !== hotelPreview.minPrice) {
                        hotelPreview.hasDiscount = true;
                    }
                }
        });*/

        this.hotels.push(hotelPreview);
    }

    getHotels = () => this.resultsContainer.getHotels();

    fillLocationInfo(groupName) {
        const location = new Map<string, Array<string>>();
        this.offerInfo.hotelPois
            .filter(poi => {
                return (poi.placeOfInterest.groupName === groupName);
            })
            .map(poi => {
                if (location.has(poi.placeOfInterest.name)) {
                    const loc = poi.name + ' (' + poi.distance + ' ' + poi.milesKm + ')';
                    location.get(poi.placeOfInterest.name).push(loc);
                } else {
                    const arr = new Array<string>();
                    const loc = poi.name + ' (' + poi.distance + ' ' + poi.milesKm + ')';
                    arr.push(loc);
                    location.set(poi.placeOfInterest.name, arr);
                }
            });
        return location;
    }

    compareExpreriences(a, b) {
        if (a.surchargeType === 'free' && b.surchargeType === 'define') {
            return -1;
        } else if (b.surchargeType === 'free' && a.surchargeType === 'define') {
            return 1;
        }
        return 0;
    }


    fillRoomPictures(pics) {
        if (pics == null) {
            return [];
        } else {
            return pics.map((r, index) => {
                if (index === 0) {
                    r.preloaded = true;
                    return r;
                } else {
                    return r;
                }
            });
        }
    }

    populateRoom(room1, rooms) {
        const checkinout: Checkin = {
            checkInTimeFrom: this.offerInfo.hotel.checkInTimeFrom,
            checkInTimeUntil: this.offerInfo.hotel.checkInTimeUntil,
            checkOutTimeFrom: this.offerInfo.hotel.checkOutTimeFrom,
            checkOutTimeUntil: this.offerInfo.hotel.checkOutTimeUntil
        };
        const hotelExtras: Map<number, any> = new Map();
        this.offerInfo.extras.forEach(element => {
            if (!hotelExtras.has(element.id)) {
                hotelExtras.set(element.id, element);
            }
        });
        let extras;

        if (room1.roomExtras !== null && room1.roomExtras !== undefined) {
            room1.roomExtras.forEach(element => {
                if (hotelExtras.has(element.id)) {
                    if (hotelExtras.get(element.id).surchargeAmount > element.surchargeAmount) {
                        element.was = hotelExtras.get(element.id).surchargeAmount;
                        element.discount = Math.round((1 - (element.surchargeAmount / element.was)) * 100);
                    }
                    hotelExtras.set(element.id, element);
                } else if (element.surchargeType) {
                    // only for personal or define in inventory or define in room settings
                    // if (hotelExtras.get(element.id).surchargeAmount > room1.roomExtras.surchargeAmount) {
                    //    element.was = parseFloat(element.surchargeType) || element.surchargeAmount;
                    // }
                    const was = parseFloat(element.surchargeType) || element.surchargeAmount;
                    if (was !== element.surchargeAmount) {
                        element.was = was;
                        element.discount = Math.round((1 - (element.surchargeAmount / element.was)) * 100);
                    }
                    hotelExtras.set(element.id, element);

                } else {
                    hotelExtras.set(element.id, element);
                }
            });
            extras = Array.from(hotelExtras.values()).sort(this.compareExpreriences);
        } else {
            extras = this.offerInfo.extras;
        }
        const room = room1.room;


        let withCancellationPrice: number;
        let withCancellationOfferPrice: number;
        let withCancellationPricingPolicy;
        let withCancellationID: number;

        let nonRefundablePrice: number;
        let nonRefundableOfferPrice: number;
        let nonRefundablePricingPolicy;
        let nonRefundableID: number;
        const roomFound = rooms.find(r => r.room.roomType.name === room.roomType.name && r.room.id !== room.id);
        // console.log(roomFound);
        // console.log(this.roomOffers.find(r => r.title === roomFound.room.roomType.name));
        if (roomFound && this.roomOffers.find(r => r.title === roomFound.room.roomType.name) !== undefined) { return null; }

        let roomMode: RoomMode;
        if (room.cancellationPolicy.nonRefundable) {
            nonRefundablePrice = room.nonRefundablePrice;
            nonRefundableOfferPrice = room.offerPrice;
            nonRefundablePricingPolicy = this.fillPricingPolicy(room);
            nonRefundableID = room.id;
            roomMode = RoomMode.NON_REFUNDABLE;
            // withCancellationPrice = room.defaultPrice;
            // withCancellationOfferPrice = room.offerPrice;
            // // withCancellationID = room.id;
            if (roomFound && !this.roomOffers.find(r => r.title === roomFound.room.roomType.name)) {
                withCancellationPrice = roomFound.room.defaultPrice;
                withCancellationOfferPrice = roomFound.room.offerPrice;
                withCancellationPricingPolicy = this.fillPricingPolicy(roomFound.room);
                withCancellationID = roomFound.room.id;
                roomMode = RoomMode.BOTH;
            }

        } else if (!room.cancellationPolicy.nonRefundable) {
            if (roomFound) {
                nonRefundablePrice = roomFound.room.defaultPrice;
                nonRefundableOfferPrice = roomFound.room.offerPrice;
                nonRefundablePricingPolicy = this.fillPricingPolicy(roomFound.room);
                nonRefundableID = roomFound.room.id;
                roomMode = RoomMode.WITH_CANCELLATION;
            }

            if (!this.roomOffers.find(r => r.title === room.roomType.name)) {
                withCancellationPrice = room.defaultPrice;
                withCancellationOfferPrice = room.offerPrice;
                withCancellationPricingPolicy = this.fillPricingPolicy(room);
                withCancellationID = room.id;
                roomMode = RoomMode.BOTH;
            }
        }


        const roomInfo: RoomInfo = {
            // id: room.id,
            title: room.roomType.name,
            roomSize: room.roomType.roomSurfaceArea,
            bathrooms: !isNaN(room.roomType.wcType.wcType) ? room.roomType.wcType.wcType : 1,
            sleepingSpaces: room.roomType.hotelRoomTypeSpaceCollection.length,
            maxPeople: room.roomType.capacity,
            pictures: this.fillRoomPictures(room1.roomTypePics),
            // price: room.defaultPrice,
            // offerPrice: room.offerPrice,
            experiences: extras.filter(extra => extra.hotelMeal === null),
            description: room.roomType.description,
            roomFacilities: room.roomType.hotelRoomPropertyCollection,
            meals: this.createMealItems(extras.filter(extra => extra.hotelMeal !== null).concat(this.offerInfo.meals)),
            handicapAccess: room.roomType.handicapAccess,
            smokingRoom: room.roomType.smokingRoom,
            liftorStairs: room.roomType.liftOrStairs,
            bedTypes: room.roomType.hotelRoomTypeSpaceCollection
                .map(space => space.hotelRoomTypeSpaceBedsCollection
                    .map(bedType => bedType.bedType.name)),
            checkin: checkinout,
            // pricingPolicy: this.fillPricingPolicy(room),
            roomType: room.roomType.roomType.roomType,
            roomTypeId: room.roomType.id,

            withCancellationPrice: withCancellationPrice,
            withCancellationOfferPrice: withCancellationOfferPrice,
            withCancellationPricingPolicy: withCancellationPricingPolicy,
            withCancellationID: withCancellationID,
            nonRefundablePrice: nonRefundablePrice,
            nonRefundableOfferPrice: nonRefundableOfferPrice,
            nonRefundablePricingPolicy: nonRefundablePricingPolicy,
            nonRefundableID: nonRefundableID,

            roomMode: roomMode,
            availability: room.availableRooms,
            available: true
        };
        return roomInfo;
    }

    fillRoomOffers() {
        // let isPersonalOffer = false;
        let rooms = new Array();
        /*if (this.offerInfo.offer.bidType.id === 2 && this.offerInfo.offerRooms.length === 0) {
           rooms = this.offerInfo.offer.bookingOfferRoomCollection;
           isPersonalOffer = true;
        } else {*/
        rooms = this.offerInfo.offerRooms;
        // }

        rooms.forEach(room => {
            let roomInfo;
            /*if (isPersonalOffer) {
                roomInfo = this.populateRoom(room, rooms);
            } else {
                // roomInfo = this.populateRoom(room.room);
                roomInfo = this.populateRoom(room, rooms);
            }*/
            roomInfo = this.populateRoom(room, rooms);
            if (roomInfo != null) {
                this.roomOffers.push(roomInfo);
            }
        });



        this.roomOffers.sort((a, b) => Math.min(a.withCancellationOfferPrice, a.nonRefundableOfferPrice) -
            Math.min(b.withCancellationOfferPrice, a.nonRefundableOfferPrice));
    }

    createMealItems(meals) {
        const finalMeals = new Array();
        meals.forEach(meal => {
            // console.log(meal);
            if (meal.hotelMeal === null || meal.hotelMeal === undefined) {
                const m = {
                    id: meal.id,
                    title: meal.mealType.mealType,
                    surchargeAmount: meal.surchargeAmount,
                    surchargeUnit: meal.surchargeUnit.surchargeUnit,
                    description: ''
                };
                finalMeals.push(m);
            } else {
                const m = {
                    id: meal.id,
                    title: meal.hotelMeal.mealType.mealType,
                    surchargeAmount: meal.surchargeAmount,
                    surchargeUnit: meal.hotelMeal.mealType.surchargeUnit.surchargeUnit,
                    hasImage: meal.hasImage,
                    description: meal.description
                };
                finalMeals.push(m);
            }
        });
        return finalMeals;

    }

    fillMealTypes() {
        this.roomOffers.forEach(room => {
            room.meals.forEach(meal => {
                this.mealtypes.add(meal.title);
            });
        });
    }


    fillPricingPolicy(offerRoom) {
        // let cancellationPolicy = this.offerInfo.offer.cancellationPolicy;
        // if (typeof offerRoom.cancellationPolicy !== 'undefined' && offerRoom.cancellationPolicy) {
        const cancellationPolicy = offerRoom.cancellationPolicy;
        // }

        let cancellationTitle = '';
        let alternativeTitle = '';
        const cancellationText = new Array<string>();
        if (offerRoom.originalId && offerRoom.cancellationPolicy.freeCancellation === false) {
            cancellationTitle = 'Non Refundable';
            alternativeTitle = 'No Refund on Cancellation';
        } else if (cancellationPolicy.freeCancellation) {
            cancellationTitle = 'Free Cancellation';
            alternativeTitle = 'Free Cancellation';
        } else if (cancellationPolicy.nonRefundable) {
            cancellationTitle = 'Non Refundable';
            alternativeTitle = 'No Refund on Cancellation';
        } else {
            cancellationTitle = 'With Cancellation';
            const pricingPolicyy = offerRoom.pricingPolicy; // this.offerInfo.offer.pricingPolicy;
            cancellationText.push(pricingPolicyy.depositPercent + '% Deposit');
            cancellationText.push(cancellationPolicy.noShow + '% No-show');

            cancellationPolicy.hotelCancellationPolicyDaysCollection.map(policyDays => {
                cancellationText.push(policyDays.feePercent + '% Cancellation fee prior to ' + policyDays.daysLessThan + ' days');
            });
        }

        if (cancellationText.length === 0) {
            const pricingPolicyy = offerRoom.pricingPolicy; // this.offerInfo.offer.pricingPolicy;
            cancellationText.push(pricingPolicyy.depositPercent + '% Deposit');
            cancellationText.push(cancellationPolicy.noShow + '% No-show');
            cancellationText.push(alternativeTitle);
        }

        const childrenOffers = new Array<string>();
        this.offerInfo.childrenOfferType.map(childrenType => {
            if (childrenType.applyDiscount) {
                childrenOffers.push('Free! All ' + childrenType.childrenType.childrenType +
                    ' under ' + childrenType.childrenMaxAge + ' year' + (childrenType.childrenMaxAge !== 1) ? 's' : '' +
                    ' stay free of charge for children\'s cots/cribs.');
            } else {
                const sornot = (childrenType.childrenMaxAge !== 1) ? 's' : '';
                childrenOffers.push('All ' + childrenType.childrenType.childrenType +
                    ' under ' + childrenType.childrenMaxAge + ' year' + sornot +
                    ' have ' + childrenType.hotelAutomatedOfferChildrenTypeDiscountCollection[0].discountPercentage +
                    ' for children\'s cots/cribs.');
            }
        });

        const pricingPolicy: PricingPolicy = {
            title: cancellationTitle,
            alternativeTitle: alternativeTitle,
            titleTooltip: cancellationText,
            cancelationPrepayment: cancellationText,
            childrenOffers: childrenOffers
        };
        return pricingPolicy;
    }

    fillTabHeaderInfo(noOfAdults, noOfChildren) {
        const roomPeople = {
            rooms: 1,
            adults: noOfAdults,
            children: noOfChildren
        };

        this.tabHeaderInfo = {
            checkin: '10/05/2020',
            checkout: '14/05/2020',
            numberOfNights: 5,
            roomPeople: roomPeople,
            numberOfNightsSafari: 5
        };
    }

    getNights(from, to) {
        const date1 = new Date(from);
        const date2 = new Date(to);
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    getNightsSafari(from, to) {
        const fromDate = from.replace(/-/g, '/');
        const toDate = to.replace(/-/g, '/');
        const date1 = new Date(fromDate);
        const date2 = new Date(toDate);
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    scrollToAmentities() {
        const el = document.getElementById('amentities');
        el.scrollIntoView({ behavior: 'smooth' });
        document.getElementById('amentities').scrollTop += 40;
    }

    scrollToDetails() {
        const el = document.getElementById('details');
        el.scrollIntoView({ behavior: 'smooth' });
        document.getElementById('details').scrollTop += 40;
    }

    scrollToLocation() {
        const el = document.getElementById('location');
        el.scrollIntoView({ behavior: 'smooth' });
        document.getElementById('location').scrollTop += 40;
    }

    scrollToRooms() {

        const el = document.getElementById('rooom-title');
        el.scrollIntoView({ behavior: 'smooth' });
        document.getElementById('location').scrollTop += 40;
    }

    formatDate(date) {
        const monthNames = [
            'January', 'February', 'March',
            'April', 'May', 'June', 'July',
            'August', 'September', 'October',
            'November', 'December'
        ];
        const dayNames = [
            'Sunday', 'Monday', 'Tuesday',
            'Thursday', 'Wednesday', 'Friday', 'Saturday'];

        const day = date.getDate();
        const weekDay = date.getDay();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();

        return dayNames[weekDay] + ', ' + day + ' ' + monthNames[monthIndex] + ' ' + year;
    }

    selectMeal(data) {
        let totalCost = 0;
        this.roomsForBooking = data[0];
        this.resultsContainer.roomsForBooking = data[0];
        data[0].forEach((info, key, map) => {
            totalCost += info.roomCost;
            info.experienceTypes.forEach((costInfo, key1, map1) => {
                totalCost += (costInfo.costPerItem * costInfo.quantity);
            });
            info.roomMealTypes.forEach((costInfo, key1, map1) => {
                totalCost += (costInfo.costPerItem * costInfo.quantity);
            });
            const index1 = this.roomOffers.map(roomOffer => roomOffer.withCancellationID).indexOf(key);
            const index2 = this.roomOffers.map(roomOffer => roomOffer.nonRefundableID).indexOf(key);
            if (index2 > -1) {
                this.selectedRoomTypes.set(key, this.roomOffers[index2].roomType);
            } else if (index1 > -1) {
                this.selectedRoomTypes.set(key, this.roomOffers[index1].roomType);
            }

        });

        // Remove rooms that are not selected anymore
        this.selectedRoomTypes.forEach((info, key, map) => {
            if (!data[0].has(key)) {
                this.selectedRoomTypes.delete(key);
            }
        });
        this.currentTotalCost = totalCost;
        this.resultsContainer.currentTotalCost = this.currentTotalCost;
        this.hotelInfo = {
            title: this.offerInfo.hotel.name, stars: this.offerInfo.hotel.starRating,
            location: this.offerInfo.hotel.addressLine1 + ',' + this.offerInfo.hotel.addressCity + ',' + this.offerInfo.hotel.country,
            cost: totalCost
        };
        this.resultsContainer.setHeaderInfo(this.hotelInfo);
    }



    bookNow(data) {
        if (this.isUserLoggedIn()) {
            this.resultsContainer.requestForSearch.totalprice = this.currentTotalCost;
            this.resultsContainer.fillRequestInfoNew(this.resultsContainer.requestForSearch);
            this.sharedContainer.generalState$.dispatch(new ChangeLasteRequestAsked(1,
                { lastRequestAsked: this.resultsContainer.myRequestInfo }));
            // this.resultsContainer.createRequest(this.offerInfo, this.offerId, this.currentTotalCost);
            this.resultsContainer.goToBooking(this.offerInfo, this.offerId, this.currentTotalCost);
        } else {
            this.resultsContainer.roomsForBooking = this.roomsForBooking;
            this.resultsContainer.openLoginModal();
            setTimeout(() => {
                const signInBtn = <HTMLElement>document.getElementById('signIn');
                signInBtn.click();
            }, 600);
        }
    }

    isUserLoggedIn() {
        return this.sharedContainer.isLoggedIn$;
    }

    isMobile() {
        const w = window.innerWidth;
        if (w < 992) {
            return true;
        }
        return false;
    }

    getAdults() {
        return this.offerInfo.bookingRequest.roompersons.reduce((sum, current) => (sum + parseInt(current.adults, 10)), 0);
    }

    getChildren() {
        return this.offerInfo.bookingRequest.roompersons.reduce((sum, current) => (sum + current.children.length), 0);
    }

    getNightsSafariFormatted(from, to) {
        from = from.replace(/-/g, '/');
        to = to.replace(/-/g, '/');
        const date1 = new Date(from);
        const date2 = new Date(to);
        this.formattedFromDate = this.getFormatedDate(date1);
        this.formattedToDate = this.getFormatedDate(date2);
    }

    getFormatedDate(date) {
        const selectedDate = new Date(date);
        return (selectedDate.getDate() + '/'
            + (selectedDate.getMonth() + 1) + '/'
            + selectedDate.getFullYear());
    }

    onSlidePropertyPics({ prev, current, direction }) {
        if (this.offerInfo.propertyPics[current]) {
            this.offerInfo.propertyPics[current].preloaded = true;
        }
        if (this.offerInfo.propertyPics[current + 1]) {
            this.offerInfo.propertyPics[current + 1].preloaded = true;
        }
    }

    onSlideHotelPics({ prev, current, direction }) {
        if (this.offerInfo.pictures[current]) {
            this.offerInfo.pictures[current].preloaded = true;
        }
        if (this.offerInfo.pictures[current + 1]) {
            this.offerInfo.pictures[current + 1].preloaded = true;
        }
    }


    openMapWindow() {
        document.getElementById('right').style.width = 'calc(100% + 15px)';
        document.getElementById('total-book').style.visibility = 'hidden';
        this.mobileFullsreenWindow.isMapOpen = true;
    }

    openMapWindowDesktop() {
        if (this.isMapDesktopOpen) {
            this.isMapDesktopOpen = false;
        } else {
            this.isMapDesktopOpen = true;
        }
    }

    closeFilterWindow() {
        this.mobileFullsreenWindow.isMapOpen = false;
        document.getElementById('right').style.width = '0';
        document.getElementById('total-book').style.visibility = 'visible';
    }

    isMapReady() {
        if (this.resultsContainer.getMapCenter().latitude !== 0) { return true; }
    }

    readMore() {

        const dots = document.getElementById('dots');
        const moreText = document.getElementById('more');
        const btnText = document.getElementById('myBtn');

        if (dots.style.display === 'none') {
            dots.style.display = 'inline';
            btnText.innerHTML = 'Read more';
            moreText.style.display = 'none';
        } else {
            dots.style.display = 'none';
            btnText.innerHTML = 'Read less';
            moreText.style.display = 'inline';
        }
    }

    highlightText(event) {
        this.isTextHighlighted = event;
    }
}

export interface TabHeaderInfo {
    roomPeople;
    checkin: string;
    checkout: string;
    numberOfNights: number;
    numberOfNightsSafari: number;
}

export interface HotelDescription {
    description: string;
    staffDescription: Array<string>;
    languages: Array<string>;
    personalDescription: string;
}

export interface FacilitiesTabInfo {
    general: Array<string>;
    activities: Array<string>;
    services: Array<string>;
}

export interface LocationTabInfo {
    shopping: Map<string, Array<string>>;
    transportation: Map<string, Array<string>>;
    nearby: Map<string, Array<string>>;
    healthCenters: Map<string, Array<string>>;
    culture: Map<string, Array<string>>;
    landmarks: Map<string, Array<string>>;
    emergencyStations: Map<string, Array<string>>;
}

export interface RoomInfo {
    title: string;
    roomSize: string;
    bathrooms: number;
    sleepingSpaces: number;
    maxPeople: number;
    pictures: Array<any>;
    experiences: Array<any>;
    description: string;
    roomFacilities: Array<string>;
    meals: Array<any>;
    handicapAccess: boolean;
    smokingRoom: string;
    liftorStairs: string;
    bedTypes: Array<string>;
    checkin: Checkin;
    roomType: string;
    roomTypeId: number;

    withCancellationPrice: number;
    withCancellationOfferPrice: number;
    withCancellationPricingPolicy;
    withCancellationID: number;

    nonRefundablePrice: number;
    nonRefundableOfferPrice: number;
    nonRefundablePricingPolicy;
    nonRefundableID: number;

    roomMode: RoomMode;

    availability: number;
    available: boolean;
}


export interface Checkin {
    checkInTimeFrom;
    checkInTimeUntil;
    checkOutTimeFrom;
    checkOutTimeUntil;
}

export interface PricingPolicy {
    title: string;
    alternativeTitle: string;
    titleTooltip: Array<string>;
    cancelationPrepayment: Array<string>;
    childrenOffers: Array<string>;
}

export interface CalendarActiveDates {
    dates: Array<number>;
    color: string;
    title: string;
}
